import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({
  open, title, description, confirmLabel = "Delete", onConfirm, onCancel, busy = false, testId = "confirm-dialog",
}) => (
  <AlertDialog open={open} onOpenChange={(v) => !v && !busy && onCancel()}>
    <AlertDialogContent data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="text-sm text-slate-600 space-y-2">{description}</div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          disabled={busy}
          onClick={(e) => { e.preventDefault(); onConfirm(); }}
          className="bg-rose-600 hover:bg-rose-700"
          data-testid={`${testId}-confirm`}
        >
          {busy ? "Working…" : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
